/** @jsx h */
import { showCount, labels } from '../config';
import Pagination from './Pagination';
import ResultTitle from './ResultTitle';

const TeaserArticle = ({
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
}) => {
  function handleLoadMoreClick() {
    loadMore();
  }
  return (
    <div className="search__results">
      {allResultCount && showCount && (
        <header className="search__results-header">
          <ResultTitle allResultCount={allResultCount} />
          <span className="is-text-l">{labels.results.sortDate}</span>
        </header>
      )}

      <ul className="search__results-wrapper">
        {list.map(result => (
          <li
            className="search__results-item search__results-item--image"
            key={result.uid}
          >
            {result.picture && (
              <a
                href={result.url}
                tabindex="-1"
                aria-hidden="true"
                className="search__results-image"
              >
                <picture
                  className="search-results__image"
                  key={`${result.uid}-picture`}
                >
                  {result.picture.map((pic, index) => {
                    if (pic.tag === 'img') {
                      return (
                        <img
                          key={`${pic.src || pic.srcset}-${index}`}
                          src={pic.src}
                          alt={pic.alt}
                          title={pic.title}
                        />
                      );
                    } else {
                      return (
                        <source
                          key={`${pic.src || pic.srcset}-${index}`}
                          srcset={pic.srcset}
                          media={pic.media}
                          type={pic.type}
                        />
                      );
                    }
                  })}
                </picture>
              </a>
            )}
            <div className="search-results__text-wrapper">
              {result.mark && (
                <ul class="search__results-labels">
                  {result.mark.map(m => {
                    return (
                      <li className="search__results-label" key={m}>
                        {m}
                      </li>
                    );
                  })}
                </ul>
              )}
              <h3 href={result.url} className="search-results__heading">
                {result.title}
              </h3>
              <p className="search-results__copy is-text">{result.teaser}</p>
              <a
                href={result.url}
                className="link-internal is-text search-results__more"
                {...(result.isExternal
                  ? { target: '_blank', rel: 'noopener' }
                  : '')}
              >
                <span>{labels.results.readMore}</span>
              </a>
            </div>
          </li>
        ))}
      </ul>

      <Pagination
        pagination={pagination}
        triggerLoadMore={handleLoadMoreClick}
        pluginNamespace={pluginNamespace}
      />
    </div>
  );
};

export default TeaserArticle;
